module.exports = __webpack_public_path__ + "static/media/vtex39.3b879f94.png";